import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { BarChart, XAxis, YAxis, Tooltip, Bar, Text, LabelList, ResponsiveContainer } from "recharts";
import EmptyPlaceholder from "../../../../../components/EmptyPlaceholder/EmptyPlaceholder";
import { theme } from "../../../../../styles/theme";
import { washDashboardStyles } from "../WashDashboardStyles";
import { washCountCardStyle } from "./WashCountCardStyle";
import { activityStatuses } from "features/activity/activityConsts";

const WashCountCard = ({ washes }) => {

    const classes = washDashboardStyles();
    const { filters } = useSelector(state => state.dashboardState);
    const washesGrouped = {};

    const completedStatuses = [activityStatuses.CompleteBilling, activityStatuses.Completed, activityStatuses.PendingInvoice, activityStatuses.CompletedAndPaid];

    //Hard-coded showing last six months
    const filtered = washes?.filter(wash =>
        (moment(wash.activityDate, 'YYYY-MM-DD').isBetween(moment().subtract(6, 'months'), moment(), undefined, '[]'))
        && completedStatuses.includes(wash.activityStatus));
    filtered?.forEach(wash => {
        let displayDate = moment(wash.activityDate).format('YYYYMM').toString();
        if (!washesGrouped[displayDate]) {
            washesGrouped[displayDate] = { displayDate: displayDate, count: 1 };
        }
        else {
            washesGrouped[displayDate].count += 1;
        }
    });
    let sortedReqs = Object.values(washesGrouped)?.sort((a, b) => (a?.date - b?.date));

    const formatDate = (date) => {
        return moment(date).format('MMM YY').toString();
    }

    return (
        <div style={{ height: 320 }}>
            {!!sortedReqs?.length ?
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={sortedReqs}>
                        {/* <YAxis
                            axisLine={false}
                            tickLine={false}
                        /> */}
                        <XAxis
                            axisLine={false}
                            dataKey="displayDate"
                            tickLine={false}
                            interval={0}
                            tick={{
                                color: theme.palette.primary.main,
                                fontSize: '0.8em',
                                fontWeight: '500',
                            }}
                            tickFormatter={date => {
                                return formatDate(date).toUpperCase()
                            }}
                            angle={-90}
                            textAnchor="end"
                            height={50}
                        />

                        <Tooltip
                            content={(val) => <GraphTooltip val={val} />}
                        />
                        <Bar
                            dataKey="count"
                            fill={'#99D3FF'}
                            minPointSize={20}
                        >
                            <LabelList dataKey="count" position="insideTop" style={{ fill: 'white' }} />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer> :
                <EmptyPlaceholder text='No Washes' />}
        </div>
    )
}

export default WashCountCard;

const GraphTooltip = ({ val }) => {
    const classes = washDashboardStyles();
    return (
        <div className={classes.tooltip}>
            <div>{val.payload?.[0]?.value} completed {val.payload?.[0]?.value > 1 ? 'washes' : 'wash'}</div>
        </div>
    )
}